// extracted by mini-css-extract-plugin
var _1 = "NotFoundPortal_content__ef891";
var _2 = "NotFoundPortal_logo__45373";
var _3 = "NotFoundPortal_root__f9ee4";
export { _1 as "content", _2 as "logo", _3 as "root" }
